import React from "react";
import { compact, isEmpty, map, upperFirst } from "lodash";
import { Descriptions } from "antd";
import { EMPTY } from "constants/common";
import { AICC_CONVERSATION_TYPE } from "constants/aicc";
import { AiccConversationDetail } from "types/model/aiccCustomer";
import styles from "./Context.module.scss";

interface Props {
  detail?: AiccConversationDetail;
}

interface Item {
  label: string;
  content: React.ReactNode;
  span?: number;
}

function Context({ detail }: Props) {
  const context = detail?.context;
  const canDoStatements = context?.canDoStatements ?? [];
  const isLessonReview = detail?.type === AICC_CONVERSATION_TYPE.lessonReview;

  const items: Item[] = compact([
    {
      label: isLessonReview ? "Level and Lesson" : "Scenario Title",
      content: context?.title || EMPTY,
    },
    isLessonReview
      ? { label: "Script Index", content: context?.scriptIndex ?? EMPTY }
      : { label: "Learner Context Description", content: context?.description || EMPTY },
    isLessonReview
      ? { label: "Script Title", content: context?.scriptTitle || EMPTY, span: 2 }
      : { label: "AI Context Description", content: context?.contextDescription || EMPTY, span: 2 },
    { label: "Voice Gender", content: upperFirst(context?.voiceGender) || EMPTY },
    { label: "User Fluency Level Snapshot", content: context?.userFluencyLevel ?? EMPTY },
    { label: "Conversation Fluency Level", content: context?.conversationFluencyLevel ?? EMPTY },
    !isLessonReview && {
      label: "Default Scenario",
      content: context?.isDefaultScenario === undefined ? EMPTY : context.isDefaultScenario ? "Yes" : "No",
    },
    {
      label: "Can-Do Statements",
      span: 2,
      content: isEmpty(canDoStatements) ? (
        EMPTY
      ) : (
        <ul className={styles.statementList}>
          {map(canDoStatements, (statement, index) => (
            <li key={index}>{statement}</li>
          ))}
        </ul>
      ),
    },
  ]);

  return (
    <Descriptions bordered column={2} className={styles.context}>
      {map(items, ({ label, content, span }) => (
        <Descriptions.Item key={label} label={label} span={span}>
          {content}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );
}

export default Context;
